module.exports = __webpack_public_path__ + "static/media/auditorium-banner.8659650b.png";